"use client";

import { useTranslations } from "next-intl";
import type * as React from "react";
import type { GlobalStakeStats } from "@/hooks/stake/useGlobalStakeStats";
import { formatStakeNumber } from "@/lib/stake/format-number";

interface StakedCountBoxesProps {
  stats: GlobalStakeStats | undefined;
}

const Box: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-2 rounded-lg bg-bg-secondary border border-stroke-light px-2 py-3 text-center">
    <p className="text-xs text-text-secondary">{label}</p>
    <span className="text-sm font-bold text-text-primary font-inter" dir="ltr">
      {value}
    </span>
  </div>
);

/** Two stacked boxes: staked NFT count + staked DNM total. */
export const StakedCountBoxes: React.FC<StakedCountBoxesProps> = ({
  stats,
}) => {
  const t = useTranslations("stake");
  return (
    <div className="flex flex-col gap-2 h-full">
      <Box
        label={t("globalStats.stakedNfts")}
        value={stats ? formatStakeNumber(stats.totalLandStaked) : "—"}
      />
      <Box
        label={t("globalStats.stakedDnm")}
        value={stats ? formatStakeNumber(stats.totalDnmStakedWei) : "—"}
      />
    </div>
  );
};
